import "core-js/modules/es.number.to-fixed.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "pc-select"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  key: 0
};
var _hoisted_4 = {
  class: "price-select-wrapper"
};
var _hoisted_5 = {
  class: "price-name"
};
var _hoisted_6 = {
  class: "price-description"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "price-accounting"
};
var _hoisted_9 = {
  key: 0,
  class: "d-flex fl-j-c fl-a-c price-value-container w-100"
};
var _hoisted_10 = {
  class: "price-accounting editable"
};
var _hoisted_11 = {
  class: "edit-price-button"
};
var _hoisted_12 = ["onClick"];

var _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M832 512a32 32 0 1164 0v352a32 32 0 01-32 32H160a32 32 0 01-32-32V160a32 32 0 0132-32h352a32 32 0 010 64H192v640h640V512z"
}, null, -1);

var _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M469.952 554.24l52.8-7.552L847.104 222.4a32 32 0 10-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 010 135.808l-331.84 331.84a32 32 0 01-18.112 9.088L436.8 623.68a32 32 0 01-36.224-36.224l15.104-105.6a32 32 0 019.024-18.112l331.904-331.84a96 96 0 01135.744 0z"
}, null, -1);

var _hoisted_15 = [_hoisted_13, _hoisted_14];
var _hoisted_16 = {
  key: 1,
  class: "price-accounting"
};
var _hoisted_17 = {
  key: 0,
  style: {
    "font-size": "8px",
    "line-height": "8px"
  }
};
var _hoisted_18 = ["onUpdate:modelValue", "disabled", "min"];
var _hoisted_19 = {
  key: 0,
  class: "input-error"
};
var _hoisted_20 = {
  key: 1,
  class: "input-error"
};
var _hoisted_21 = {
  key: 0,
  class: "max-quantity-reached"
};
var _hoisted_22 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_form_item = _resolveComponent("el-form-item");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_form = _resolveComponent("el-form");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  var _component_calculator = _resolveComponent("calculator");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    title: _ctx.productCategoryFullName,
    top: _ctx.getModalTop,
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    width: "80%"
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_22, [_createVNode(_component_el_button, {
        onClick: _ctx.hideDialog,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.isLoading,
        disabled: _ctx.isDisabled || !_ctx.canBook,
        onClick: _ctx.addToBasket,
        class: "booking-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
        }),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_form, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_row, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_col, {
                span: 4
              }, {
                default: _withCtx(function () {
                  return [_ctx.pc ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.productPicture
                  }, null, 8, _hoisted_2)) : _createCommentVNode("", true)];
                }),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 10
              }), _createVNode(_component_el_col, {
                span: 10
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, null, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "key"
                          }, {
                            default: _withCtx(function () {
                              return [_createTextVNode(_toDisplayString(_ctx.$t("field.availability")), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "value"
                          }, {
                            default: _withCtx(function () {
                              return [_createTextVNode(_toDisplayString(_ctx.availabilities) + " " + _toDisplayString(_ctx.isRetail ? _ctx.$t("pcselect.left") : _ctx.$t("pcselect.tickets-left")), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), !_ctx.isRetail ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "key"
                          }, {
                            default: _withCtx(function () {
                              return [_createTextVNode(_toDisplayString(_ctx.$t("field.start-date-time")), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "value"
                          }, {
                            default: _withCtx(function () {
                              var _ctx$ts;

                              return [_createTextVNode(_toDisplayString(_ctx.formatDateTime((_ctx$ts = _ctx.ts) === null || _ctx$ts === void 0 ? void 0 : _ctx$ts.startDateTime)), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })) : _createCommentVNode("", true), !_ctx.isRetail ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 1
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "key"
                          }, {
                            default: _withCtx(function () {
                              return [_createTextVNode(_toDisplayString(_ctx.$t("field.end-date-time")), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form_item, {
                            class: "value"
                          }, {
                            default: _withCtx(function () {
                              var _ctx$ts2;

                              return [_createTextVNode(_toDisplayString(_ctx.formatDateTime((_ctx$ts2 = _ctx.ts) === null || _ctx$ts2 === void 0 ? void 0 : _ctx$ts2.endDateTime)), 1)];
                            }),
                            _: 1
                          })];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })) : _createCommentVNode("", true), _createVNode(_component_el_row)];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_divider, {
        class: "price-list-divider"
      }), _ctx.pc ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPrices(_ctx.pc.prices), function (price, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "price-selector d-flex fl-a-c",
          key: price.id,
          ref_for: true,
          ref: "pricesRef"
        }, [_createVNode(_component_el_row, {
          class: "w-100"
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_col, {
              span: 6,
              class: "price-name-wrapper"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.priceName(price)), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.truncatePriceDescription(_ctx.priceDescription(price), _ctx.priceDescriptionMaxLength)), 1), _ctx.priceDescription(price).length > _ctx.priceDescriptionMaxLength ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "see-more",
                  onClick: function onClick($event) {
                    return _ctx.togglePriceDescription(index, _ctx.priceDescription(price), _ctx.priceDescriptionMaxLength);
                  }
                }, _toDisplayString(_ctx.$t("button.see-more")), 9, _hoisted_7)) : _createCommentVNode("", true)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              class: "d-flex fl-j-c fl-a-c",
              span: 2
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.pc.product.currency), 1)];
              }),
              _: 1
            }), _createVNode(_component_el_col, {
              class: "d-flex fl-j-c fl-a-c",
              span: 3
            }, {
              default: _withCtx(function () {
                return [_ctx.isPriceValueEditable(price) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(((_ctx.getEditedPriceValue(price.id) || price.value) / 100).toFixed(2)), 1), _createElementVNode("div", _hoisted_11, [(_openBlock(), _createElementBlock("svg", {
                  onClick: function onClick($event) {
                    return _ctx.editPrice(price.id);
                  },
                  class: "icon",
                  width: "30",
                  height: "30",
                  viewBox: "0 0 1024 1024",
                  xmlns: "http://www.w3.org/2000/svg",
                  "data-v-042ca774": ""
                }, _hoisted_15, 8, _hoisted_12))])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(((_ctx.pssCustomizedPriceValue(price.id) || price.value) / 100).toFixed(2)), 1), _ctx.isPssCustomizedPriceValue(price.id) ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("field.customized-price")), 1)) : _createCommentVNode("", true)]))];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              class: "d-flex fl-j-c fl-a-c",
              span: 1
            }), _createVNode(_component_el_col, {
              class: "d-flex fl-j-c fl-a-c",
              span: 2
            }), _createVNode(_component_el_col, {
              span: 8,
              class: "d-flex fl-j-c fl-a-c"
            }, {
              default: _withCtx(function () {
                var _ctx$pc, _ctx$pc2;

                return [_createVNode(_component_el_button, {
                  class: _normalizeClass(["is-fullwidth price-button", {
                    transparent: _ctx.pricesCount[price.id] === 0 || _ctx.countPssAllConfirmed(price.id, _ctx.pricesCount[price.id])
                  }]),
                  type: "primary",
                  size: "large",
                  disabled: _ctx.isPssCustomizedPriceValue(price.id) || _ctx.countPssAllConfirmed(price.id, _ctx.pricesCount[price.id]),
                  onClick: function onClick($event) {
                    return _ctx.decrease(price.id);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode("- ")];
                  }),
                  _: 2
                }, 1032, ["class", "disabled", "onClick"]), _withDirectives(_createElementVNode("input", {
                  style: {
                    "position": "relative"
                  },
                  type: "number",
                  class: "price-count d-flex fl-a-c fl-j-c",
                  "onUpdate:modelValue": function onUpdateModelValue($event) {
                    return _ctx.pricesCount[price.id] = $event;
                  },
                  disabled: _ctx.isPssCustomizedPriceValue(price.id),
                  min: _ctx.countConfirmedPSS(price.id)
                }, null, 8, _hoisted_18), [[_vModelText, _ctx.pricesCount[price.id], void 0, {
                  number: true
                }]]), _ctx.pricesCount[price.id] && !_ctx.sellOnSoldOut((_ctx$pc = _ctx.pc) === null || _ctx$pc === void 0 ? void 0 : _ctx$pc.prices, (_ctx$pc2 = _ctx.pc) === null || _ctx$pc2 === void 0 ? void 0 : _ctx$pc2.type) && !_ctx.sharedStocksWithOverbooking && _ctx.pricesCount[price.id] > _ctx.maxInputValue(price.id) ? (_openBlock(), _createElementBlock("label", _hoisted_19, _toDisplayString(_ctx.$t("error.quantiy-less-than") + " " + String(_ctx.maxInputValue(price.id) + 1)), 1)) : _createCommentVNode("", true), _ctx.pricesCount[price.id] < _ctx.countConfirmedPSS(price.id) ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t("error.quantiy-more-than") + " " + String(_ctx.countConfirmedPSS(price.id) - 1)), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(_component_el_button, {
                  class: _normalizeClass(["is-fullwidth price-button", {
                    transparent: _ctx.isPriceMaxQuantityReached(price.id)
                  }]),
                  type: "primary",
                  size: "large",
                  disabled: _ctx.isPssCustomizedPriceValue(price.id),
                  onClick: function onClick($event) {
                    return _ctx.increase(price.id);
                  }
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode("+ ")];
                  }),
                  _: 2
                }, 1032, ["class", "disabled", "onClick"]), _ctx.isPriceMaxQuantityReached(price.id) ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.$t("pcselect.max-quantity-reached")), 1)) : _createCommentVNode("", true)])];
              }),
              _: 2
            }, 1024)];
          }),
          _: 2
        }, 1024)]);
      }), 128))])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["title", "top", "modelValue"])]), _ctx.showNewPriceCalculator ? (_openBlock(), _createBlock(_component_calculator, {
    key: 0,
    onConfirmNumber: _ctx.handleCalculatorClick,
    onCancelCalculator: _ctx.hideCalculator,
    visible: _ctx.showNewPriceCalculator,
    placeHolderValue: _ctx.pricePlaceHolder
  }, null, 8, ["onConfirmNumber", "onCancelCalculator", "visible", "placeHolderValue"])) : _createCommentVNode("", true)], 64);
}